import { useState } from "react";
import "./Login.css";
import logo from "./assets/Spark-Logo.png";

export default function Login({ onLogin }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleLogin = async () => {
        setError("");

        const res = await fetch("https://sda-chat-api-d3eeg6hcewf8gdde.ukwest-01.azurewebsites.net/auth/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, password })
        });

        const data = await res.json();

        if (data.needsPassword) {
            onLogin({ needsPassword: true, email });
            return;
        }

        if (res.ok) {
            localStorage.setItem("token", data.token);
            localStorage.setItem("user", JSON.stringify(data.user));

            onLogin(data.user);
        } else {
            setError(data.error || "Invalid login");
        }
    };

    return (
        <div className="login-wrapper">
            <img src={logo} className="LogoLogin" alt="Spark Design Academy" />
            <div className="login-card">
                <h2>Student Login</h2>

                {error && <div className="login-error">{error}</div>}

                <input
                    type="email"
                    placeholder="Email address"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                />

                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />

                <button onClick={handleLogin}>Log In</button>
            </div>
            <div className="login-info-box">
                <span className="info-icon">?</span>
                <p>
                    If you don’t have an account, please
                    <a href="mailto:admin@sparkdesign.academy"> contact your administrator</a>.
                </p>
            </div>
            <div className="login-footer-bottom">
                © Spark Design Academy 2025<br />
                <span className="powered">
                    Powered by <a href="https://wearemomentm.co.uk" target="_blank" rel="noopener noreferrer">Momentm</a>
                </span>
            </div>
        </div>
    );
}